import { HttpStatusCode } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Contrato } from 'src/app/admihair/api/dto/contrato';
import { ContratoRateio } from 'src/app/admihair/api/dto/contrato-rateio';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { ExceptionDto } from 'src/app/admihair/api/dto/exception/exception-dto';
import { Grupo } from 'src/app/admihair/api/dto/grupo';
import { Profissional } from 'src/app/admihair/api/dto/profissional';
import { Subgrupo } from 'src/app/admihair/api/dto/subgrupo';
import { Usuario } from 'src/app/admihair/api/dto/usuario';
import { ContratoRateioService } from 'src/app/admihair/service/contrato-rateio.service';
import { ContratoService } from 'src/app/admihair/service/contrato.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { GrupoService } from 'src/app/admihair/service/grupo.service';
import { ProfissionalService } from 'src/app/admihair/service/profissional.service';
import { SubgrupoService } from 'src/app/admihair/service/subgrupo.service';
import { UsuarioService } from 'src/app/admihair/service/usuario.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { FormatacaoUtil } from 'src/app/admihair/util/formatacao-util';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { map, tap } from 'rxjs';

@Component({
  selector: 'app-profissional-inserir',
  templateUrl: './profissional-inserir.component.html',
  styleUrls: ['./profissional-inserir.component.scss']
})
export class ProfissionalInserirComponent extends AdmihairBaseComponent implements OnInit {

  progressoRequisicao: boolean = false;
  progressoReqUsuario: boolean = false;

  empresaSelecionada?: Empresa;
  profissional: Profissional = {};
  cpfInformado?: string;
  usuario: Usuario = {};
  contratos: Contrato[] = [];
  contratoSalvo?: Contrato;
  contratoSalvoModal: boolean = false;
  emailValido: boolean = true;
  loadingCadastroContrato: boolean = false;

  valorAgenda: boolean = false;
  desabilitaCampoCpf: boolean = false;
  mostrarModalUsuario: boolean = false;
  mostrarModalContrato: boolean = false;
  tipos: SelectItem[] = [
    { label: 'COLABORADOR', value: 'COLABORADOR' },
    { label: 'PARCEIRO', value: 'PARCEIRO' }
  ]

  contrato: Contrato = {};
  listaGrupos: Grupo[] = [];
  grupoSelecionado: Grupo = {};
  listaRateios: ContratoRateio[] = [];
  @ViewChild('f') form?: NgForm;


  constructor(
    private profissionalService: ProfissionalService,
    private usuarioService: UsuarioService,
    private contratoService: ContratoService,
    private contratoRateioService: ContratoRateioService,
    private grupoService: GrupoService,
    private subgrupoService: SubgrupoService,
    private confirmationService: ConfirmationService,
    erroService: ErroService,
    utilStorageService: UtilStorageService) {
    super(erroService, utilStorageService)
  }


  ngOnInit(): void {
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_PROFISSIONAL');
    this.empresaSelecionada = this.getEmpresa();
    this.buscarContratos();
  }

  buscarContratos() {
    this.contratoService.listarPorEmpresaId(this.empresaSelecionada?.id).subscribe({
      next: (data: Contrato[]) => {
        this.contratos = data;
        if (this.contratoSalvoModal) {
          this.selecionaTipo('PARCEIRO');
          this.profissional.contrato = this.contratoSalvo;
        }
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    });
  }

  salvar() {
    this.progressoRequisicao = true;
    this.profissional.empresa = this.empresaSelecionada;
    this.profissional.usuario = this.usuario;
    this.profissional.cpf = this.usuario.cpf;
    this.profissional.ativo = true;
    this.profissional.agenda = this.profissional.agenda || false;
    this.profissionalService.salvar(this.profissional).subscribe({
      next: () => {
        this.profissional = {};
        this.usuario = {};

        this.contratoSalvoModal = false;
        this.buscarContratos();
        this.exibirMensagemSucesso();
        this.form?.reset();
        this.progressoRequisicao = false;
        this.rolarTela();
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
        this.progressoRequisicao = false;
      }
    })
  }

  cadastrarUsuario() {
    this.progressoReqUsuario = true;
    this.usuario.cpf = this.cpfInformado;
    this.usuario.apelido = this.formatarApelido(this.usuario.nome);
    this.usuario.senha = '';
    this.usuario.login = this.usuario.email;
    this.usuario.tipo = 'EMPRESA';
    this.usuario.situacaoConfirmacaoConta = 'AGUARDANDO_CONFIRMACAO';
    this.usuario.primeiroAcesso = true;
    this.usuarioService.salvar(this.usuario).subscribe({
      next: (data: Usuario) => {
        this.usuario = data;
        this.profissional.nomeProfissional = this.usuario.apelido
        this.mostrarModalUsuario = false;
        this.desabilitaCampoCpf = true;
        this.progressoReqUsuario = false;
      },
      error: (err: any) => {
        this.progressoReqUsuario = false;
        this.exibirMensagemErroDialog(err);

      }
    });
  }

  verificarEmailUsuario(temErro?: boolean) {
    if (!temErro && this.usuario.email) {
      this.usuarioService.buscarPorEmail(this.usuario.email).subscribe({
        next: (data: Usuario) => {
          this.emailValido = false;
        },
        error: (err: any) => {
          if (err.status === HttpStatusCode.NotFound) {
            this.emailValido = true;
          } else {
            this.exibirMensagemErro(err);
          }
        }
      });
    }

  }
  cadastrarContrato() {
    this.loadingCadastroContrato = true;
    this.contrato.razaoSocial = FormatacaoUtil.removerCaracteresEspeciais(this.contrato.razaoSocial);
    this.contrato.empresa = this.empresaSelecionada;
    this.contrato.ativoContratante = true;
    this.contrato.ativoContratado = false;
    this.contrato.tipo = 1;
    this.contrato.excluido = false;
    this.contratoService.salvar(this.contrato).subscribe({
      next: (data: Contrato) => {
        this.salvarRateios(data);
        this.messages = [{ severity: 'success', summary: 'Sucesso', detail: `Contrato: ${data.razaoSocial} criado com sucesso` }];
        this.messagemVisivel = true;
        this.contratoSalvo = data;
        this.contratoSalvoModal = true;
        this.mostrarModalContrato = false;
        this.buscarContratos();
        this.rolarTela();
      },
      error: (err: any) => {
        this.loadingCadastroContrato = false;
        this.exibirMensagemErroDialog(err);
      }

    });
  }
  salvarRateios(contrato: Contrato) {
    this.listaRateios.forEach((rateio: ContratoRateio) => {
      rateio.contrato = contrato
      this.contratoRateioService.salvar(rateio).subscribe({
        next: (data: ContratoRateio) => {
          this.loadingCadastroContrato = false;
        },
        error: (err: any) => {
          this.loadingCadastroContrato = false;
          this.exibirMensagemErro(err);
        },
      })
    })

  }


  buscarUsuario(cpf: string) {
    if (cpf && cpf.length === 11) {
      this.usuarioService.buscarPorCpf(cpf).subscribe({
        next: (data: Usuario) => {
          this.processarUsuarioBuscado(data);
        },
        error: (err: any) => {
          if (err.status == '404') {
            this.usuario = {};
            this.confirmationService.confirm({
              message: 'Deseja cadastrar o usuário?',
              header: 'CPF Sem cadastro',
              acceptLabel: 'Sim',
              rejectLabel: 'Não',
              icon: 'pi pi-info-circle',
              accept: () => {
                this.mostrarModalUsuario = true;
              }
            });

          }
        }
      });
    }
  }

  processarUsuarioBuscado(usuarioBuscado?: Usuario) {
    if (usuarioBuscado) {
  
      this.profissionalService.buscarPorEmpresaIdEUsuarioId(
        this.getEmpresa().id,
        usuarioBuscado?.id
      ).subscribe({
        next: (data: Profissional) => {
          this.confirmationService.confirm({
              message: 'Este profissional já está vinculado a um contrato',
              header: 'Profissional já cadastrado',
              acceptLabel: 'OK',
              icon: 'pi pi-info-circle',
              rejectVisible: false
            });
        },
        error: (err: any) => {
          if (err.status == '404') {
            this.usuario = usuarioBuscado;
            this.profissional.nomeProfissional = this.usuario.apelido
            this.desabilitaCampoCpf = true;
          }
        }
      })
    }
  }

  selecionaTipo(tipo?: any) {
    if (tipo === 'PARCEIRO') {
      this.contratos = this.contratos.filter(contrato =>
        contrato.cpfTitular === this.usuario.cpf);
    } else {
      this.buscarContratos();
    }
  }

  adicionarRateio() {
    this.subgrupoService.listarSubgruposPorGrupoId(this.grupoSelecionado.id).subscribe({
      next: (data: Subgrupo[]) => {
        this.listaRateios = data.map((item) => ({
          subgrupo: item,
          percentualRateio: item.rateioBasico
        }));
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    })
  }

  excluirRateio(rateio: ContratoRateio) {
    const posicao = this.listaRateios.indexOf(rateio);
    this.listaRateios.splice(posicao, 1);
  }

  fecharModalUsuario() {
    this.mostrarModalUsuario = false;
    this.usuario = {};
  }

  abrirModalContrato() {
    this.mostrarModalContrato = true;
    this.contrato.cpfTitular = this.cpfInformado;
    this.carregarGruposServico();

  }

  aoFecharDialog() {
    this.mostrarModalContrato = false;
  }

  carregarGruposServico() {
    this.grupoService.listarGruposPorEmpresaECodigoPlanoConta(this.empresaSelecionada?.id, 4).subscribe({
      next: (data: Grupo[]) => {
        this.listaGrupos = data;
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    });
  }

  liberarCampoCpf() {
    this.desabilitaCampoCpf = false;
  }
  formatarApelido(nome?: string): string {
    return nome !== undefined ? nome.split(' ')[0] : '';
  }


  tratarErroApi(exceptions: ExceptionDto[]) {
    if (exceptions.length > 0) {
      this.messages = [{ severity: 'error', summary: exceptions[0].requestId, detail: exceptions[0].data[0].message }];
    }
  }
}
